<template>
  <div class="invoiceInformation">
    <IndexHeader />
    <div class="orgTopHeaderBox">
      <div class="list-bg">
        <div class="bg-content">
          <div class="m-list"><span class="list-font">名单</span></div>
          <div class="m-content">
            <div class="m-left">
              <span>参课人数：{{ listData.courseinfo.applyCount }}人</span>
              <span>满分（{{ listData.courseinfo.credit }}分）</span>
              <span>课程编号：{{ listData.courseinfo.id }}</span>
            </div>
            <div class="m-left">
              <span class="className"
                >课程名称：{{ listData.courseinfo.name }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list-list">
      <table>
        <tr class="list-top">
          <th>姓名</th>
          <th>学校</th>
          <th>报名时间</th>
          <th>电话</th>
          <th>{{listData.courseinfo.type == 10 ? "签到情况" : "学习情况"}}</th>
        </tr>
        <tr class="content" v-for="(item, idx) in listData.list" :key="idx">
          <td>{{ item.nickName }}</td>
          <td>{{ item.workName }}</td>
          <td>{{ item.createTime }}</td>
          <td>{{ item.phonenumber }}</td>
          <td>
            <div
              class="sign studySign"
              @click="openXxqk(item.userId, item.courseId)"
            >
              {{listData.courseinfo.type == 10 ? "签到情况" : "学习情况"}}
            </div>
          </td>
        </tr>
      </table>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="listData.total"
      :page-size="query.pageSize"
      @current-change="bindPage"
    />
    <!-- 学习情况 -->
    <div class="mass" v-show="xxqkStatus">
      <div class="massBox">
        <div class="topHeader clear">
          <div class="title">学习情况</div>
          <div class="close" @click="xxqkStatus = false">
            <span class="iconfont"></span>
          </div>
        </div>
        <div class="infoEvaluate">
          <div class="table">
            <div class="tableTop">
              <div class="top-one">考核项</div>
            </div>
            <div
              class="contentOne flex"
              v-for="(item, idx) in xxqkData.list"
              :key="idx"
            >
              <div class="videostudy">
                <span>{{ item.title }}</span>
              </div>
              <div class="status">
                <span :class="item.finish ? 'green' : 'red'" v-if="idx == 0">{{
                  item.finish ? "已完成" : "未完成"
                }}</span>
                <router-link
                  v-if="idx == 1"
                  class="select white"
                  :to="{
                    path: 'xxgw',
                    query: { id: xxqkQuery.courseId, uid: xxqkQuery.userId },
                  }"
                  >{{ item.courseId }}学习感悟</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--签到情况-->
    <div class="mass" v-show="offlineStatus">
      <div class="massBox">
        <div class="topHeader clear">
          <div class="title">{{listData.courseinfo.type == 10 ? "签到情况" : "学习情况"}}</div>
          <div class="close" @click="offlineStatus = false">
            <span class="iconfont"></span>
          </div>
        </div>
        <div class="topHeader clear">
          <div class="title" style="font-size: 14px">课程有效时长：{{offlineData.duration}}</div>
        </div>
        <div class="infoEvaluate">
          <div class="table">
            <div class="tableTop">
              <div class="top-one">课程小结名称</div>
              <div class="top-circle">签到状态</div>
              <div class="top-sorce">签退状态</div>
            </div>
            <div
              class="contentOne flex"
              v-for="(item, idx) in offlineData.list"
              :key="idx"
            >
              <div class="coursesign">
                <span>{{ item.scheduleName }}</span>
              </div>
              <div class="status">
                <span :class="item.signInStatus == '已签到' ? 'green' : 'red'"> {{item.signInStatus}} </span>
              </div>
              <div class="status">
                <span :class="item.signOutStatus == '已签退' ? 'green' : 'red'"> {{item.signOutStatus}} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
  <script setup>
import IndexHeader from "../../components/IndexHeader/TopBar";
import {
  namelist,
  getfeeling,
  getOfflineSign,
} from "../../server/jigou/course";
import { ref, reactive, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";

const { proxy } = getCurrentInstance();
const route = useRoute();
const query = reactive({
  id: route.query.id,
  pageSize: 10,
  pageNum: 1,
});
const listData = reactive({
  list: {},
  total: 0,
  courseinfo: {},
  creditsStatu: "",
});
const shQuery = reactive({
  courseId: route.query.id,
});
//线上课程学习情况
const xxqkStatus = ref(false);
//线下课程学习情况
const offlineStatus = ref(false);
//获取列表
async function getList() {
  let res = await namelist(query);
  if (res != false) {
    listData.list = res.list;
    listData.courseinfo = res.courseinfo;
    listData.total = res.total;
  }
}
getList();
//批量审核
async function bindSh() {
  let res = await statusBatch(shQuery);
  if (res != false) {
    proxy.$modal.msgSuccess("批量审核成功");
  }
}
function bindPage(e) {
  query.pageNum = e;
  getList();
}
//学习情况
const xxqkQuery = reactive({
  userId: "",
  courseId: "",
});
const xxqkData = reactive({
  list: [],
  total: 0,
  status: "合格",
});
//线下课程学习情况数据
const offlineData = reactive({
  list: [],
  duration: "00:00",
});
async function openXxqk(uid, cid) {
  xxqkQuery.userId = uid;
  xxqkQuery.courseId = cid;
  if (listData.courseinfo.type == 10) {
    let res = await getOfflineSign(xxqkQuery);
    console.log(res);
    if (res != false) {
      offlineStatus.value = true;
      offlineData.duration = res.signinDuration;
      offlineData.list = res.userSigninInfoList;
    }
  } else {
    let res = await getfeeling(xxqkQuery);
    console.log(res);
    if (res != false) {
      xxqkStatus.value = true;
      xxqkData.total = res.reduce((pre, curr) => {
        console.log(pre, curr);
        return pre.credit + curr.credit;
      });
      xxqkData.status =
        res.filter((item) => !item.finish).length > 0 ? "不合格" : "合格";
      xxqkData.list = res;
      console.log(xxqkData);
    }
  }
}
</script>
<style scoped>
.orgTopHeaderBox {
  margin-top: 64px;
}
.red {
  background: unset;
}
.grren {
  color: #1eb521;
}
.select.white {
  display: inline-block;
}
</style>